module.exports = __webpack_public_path__ + "static/img/sjThree.67e4319.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sjThree.png
// module id = QKqT
// module chunks = 1